import React, { useState, useEffect } from 'react';
import { Page, Icon, Fab, Block, Preloader, Link } from 'framework7-react';
import axios from 'axios';
// import io from 'socket.io-client';
import { API_BASE_URL, API_AUTH, IMG_URL } from './../globals';
const eatBidsLogo = require('./../images/logo/eatbids-logo.png')
const TabSearch = () => {
  // const [activeButton, setActiveButton] = useState('button1');
const [data, setData] = useState([]);
const [isLoading, setIsLoading] = useState(true); 
const [showNoResult, setShowNoResult] = useState(false); 

  useEffect(() => {
    axios.get(API_BASE_URL + 'restmenu', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          menu_id: 0,
          status: 0,
          menu_type_id: 0,
          rest_id: localStorage.getItem('id'),
        }
      })
      .then(response => {
        if (response.status === 200 && response.data.length > 0) {
          setData(response.data.reverse());
          setIsLoading(false);
          setShowNoResult(false);
        } else {
          setData([]);
          setIsLoading(false);
          setShowNoResult(true);
        }
      })
      .catch(error => {
        // Handle the 404 error
        if (error.response && error.response.status === 404) {
          setData([]);
          setIsLoading(false);
          setShowNoResult(true);
        } else {
          console.log(error);
        }
      });
  }, []);
  //     .then(response => { setData(response.data.reverse()); })
  //     .catch(error => console.log(error));
  // }, []);

  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, 
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover', 
    backgroundPosition: 'top left', 
    marginTop: '-30px',
    marginBottom: '-20px',
    marginLeft: '10px',
    width: '106px', 
    height: '40px',
  };

  return (  
    <Page className='bg-white'>
      <Fab position="right-bottom" slot="fixed" href="/addmenu/">
        <Icon ios="material:add" md="material:add" />
      </Fab>
      <div className="container container-table">
        <div className="row vertical-center-row col col-md-offset-12 p-0">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel pt-3">
                <h2>Menu</h2>
              </div>
              <div className="custom-logo d-none d-md-block" style={divStyle}/>
            </div>
          </header>  
            <section>
              <div className="custom-container profile-form bg-light p-0 mt-5">
                <div className='container p-0 bg-white'>
                {isLoading ? (
                <div className='text-center mt-5'>
                  <Preloader color="orange" />
                </div>
                ) : (
                    <div className='row gy-3 '>
                      {data.length > 0 ? (
                        data.map(item => (
                          <div className='upcoming-order-div'>
                            <a href={`/editmenu/${item.menu_item_id}`}>
                              <div className="vertical-product-box order-box bg-white border">
                                <div className="vertical-box-img">
                                  {item.menu_item_picture ? (
                                    <img className="img-fluid img" src={`${IMG_URL}${item.menu_item_picture}`} alt="{item.menu_item_name}" />
                                  ):
                                  (
                                    <img className="img-fluid img" src={require("./../images/no-image.png")} alt="{item.menu_item_name}" />
                                  ) }
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5 className="dark-text text-capitalize">{item.menu_item_name}</h5>
                                      {/* <h5 className="text-success">${item.menu_item_price}</h5> */}
                                      <h5 className="text-success text-2">Edit</h5>
                                    </div>
                                    <h6 className="food-items mb-2">{item.menu_item_desc}</h6>                    
                                  </div>
                                  <div className="reorder">
                                    <h6 className="rating-star">
                                      {item.menu_type_name} <span className='text-success'>{item.menu_item_status}</span>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        ))
                        ) : showNoResult ? (
                        <Block loginScreen className='text-center bg-white'>
                          <div className="custom-container p-0">
                            <div className="empty-tab">
                              <h2>No Menu!!</h2>
                              <h5 className="mt-3">You have currently no menus.</h5>
                              <a href="/addmenu/" className="btn btn-success w-100 mt-5" role="button">Add New Menu</a>
                            </div>
                          </div>                          
                        </Block>
                      ) : null}
                    </div>
                    )}
                  </div>                  
              </div>
            </section>  
          </div> 
      </div>               
  </Page>
  );
};

export default TabSearch;